




import { ProductService, NotificationService, PurchaseRequestService } from "./firestore";








export async function checkStockLevels(userId, options = {}) {
  const { dryRun = false, skipNotifications = false } = options;


  let products;
  try {
    products = await ProductService.getProducts(userId);
  } catch {
    products = [];
  }


  const criticalProducts = products.filter(
    (p) => typeof p.currentStock === "number" && typeof p.minStockLevel === "number" && p.currentStock < p.minStockLevel
  );

  if (criticalProducts.length === 0) {
    return { criticalProducts: [], createdRequests: [] };
  }

  const createdRequests = [];

  if (!dryRun) {
    for (const product of criticalProducts) {
      const suggestedQty = (product.maxStockLevel || product.minStockLevel * 3) - product.currentStock;


      try {
        const prData = {
          productId: product.id,
          productName: product.name,
          sku: product.sku,
          currentStock: product.currentStock,
          minStockLevel: product.minStockLevel,
          suggestedQuantity: Math.max(suggestedQty, 1),
          preferredVendorId: null,
          status: "auto_generated",
          unit: product.unit || "adet",
          estimatedUnitCost: product.costPrice || 0,
          createdBy: userId
        };

        const result = await PurchaseRequestService.createRequest(prData);
        createdRequests.push({ ...prData, id: result.id });
      } catch (err) {
        console.error(`Failed to create purchase request for ${product.sku}:`, err);
      }


      if (!skipNotifications) {
        try {
          await NotificationService.create(
            userId,
            "stock_alert",
            `⚠️ Kritik stok: ${product.name} (${product.sku}) — Mevcut: ${product.currentStock}, Minimum: ${product.minStockLevel}`
          );
        } catch (err) {
          console.error(`Failed to send stock alert notification for ${product.sku}:`, err);
        }
      }
    }
  }

  return { criticalProducts, createdRequests };
}






export async function getCriticalProducts(userId) {
  let products;
  try {
    products = await ProductService.getProducts(userId);
  } catch {
    products = [];
  }
  return products.filter(
    (p) => typeof p.currentStock === "number" && typeof p.minStockLevel === "number" && p.currentStock < p.minStockLevel
  );
}




export function getPurchaseRequestStatusBadge(status) {
  const map = {
    auto_generated: { color: "warning", label: "Otomatik Oluşturuldu" },
    submitted: { color: "info", label: "Gönderildi" },
    ordered: { color: "primary", label: "Sipariş Verildi" },
    received: { color: "success", label: "Teslim Alındı" },
    cancelled: { color: "danger", label: "İptal" }
  };
  return map[status] || { color: "secondary", label: status };
}
